module.exports = __webpack_public_path__ + "static/media/the-remains-of-the-day.ba9b7564.jpg";